import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../../../reusableComponents/Spinner";
import SuccessModal from "../../../../reusableComponents/SuccessModal";
import { setLastPayment } from "../../../../store/reducers/accountSlice";
import { returnErrors } from "../../../../store/reducers/error";
import { applyCoupon, initiatePayment, updateUserDetailsRequest } from "../../../../utils/apis";
import { ReactComponent as Cross } from "../../../../assets/icons/CrossSvg.svg";
import { createFreeAccount, initiatePaymentpublic } from "../../../../utils/apis/payment";
import { Modal, Button, Typography } from "antd";
import { country as countryList } from "../../../../utils/constants/country";

import "./style.scss";

import PreSaleModal from "../../../reusableComponents/presale/PresaleCompo";
import PaytikoCashier from "../../../../pages/FundingEvaluation/paytiko/PaytikoCashier";
const { Text, Paragraph } = Typography;

// The coupon is part of what the user filled in, so a payment that sends them off
// to the provider and back must not lose it. It rides in its own localStorage key
// (the parent rewrites checkout_details wholesale) and is only honoured while a
// payment is in flight, so a fresh checkout still starts empty.
const COUPON_STORAGE_KEY = "checkout_coupon";

const readSavedCoupon = () => {
  try {
    const shouldRestore = localStorage.getItem("payment_in_progress") === "true" || localStorage.getItem("checkout_restore") === "true";
    if (!shouldRestore) return null;
    return JSON.parse(localStorage.getItem(COUPON_STORAGE_KEY) || "null");
  } catch (e) {
    return null;
  }
};

// Leaving for the provider's hosted page has to PUSH a history entry, not replace
// the checkout one. location.replace hands the provider's URL the checkout page's
// own slot, so the entry sitting behind it is whatever came before checkout - and
// after a cancel-and-retry, that is the PREVIOUS provider's page. Pressing back on
// the second provider then reopened the first provider's payment screen, live and
// payable. With assign, the entry behind a provider page is always the checkout
// page the user just left, which is where back should go.
const redirectToProvider = (url) => {
  localStorage.setItem("payment_in_progress", "true");
  window.location.assign(url);
};

const getCountryCode = (countryName) => {
  if (!countryName) return "";
  const found = countryList.find(
    (c) => c.country?.toLowerCase() === countryName.toLowerCase()
  );
  return found ? found.iso : countryName;
};

function Summary({
  user,
  email,
  paymentMethod,
  publicCheckout,
  accBalances,
  selectedValues,
  selectedAddress,
  formData,
  handleSave,
  paymentMode,
  sequrePaymentLink,
  selectedCountry,
  selectedState,
  addressDetails,
  validateofEmail,
  broker,
  selectRapydCountry,
  selectPaymidCountry,
  setAddon,
  addon,
}) {
  const { idToken } = useSelector((state) => state.auth);
  const selectedChallenge = useSelector((state) => state.account.selectedChallenge);
  const plans = useSelector((state) => state.account.plans.data);
  const [accBalance, setAccBalance] = useState(accBalances);
  useEffect(() => {
    setAccBalance(accBalances);
  }, [accBalances]);

  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  const { userAddress } = useSelector((state) => state.user);

  const activeAddr = userAddress?.find((addr) => addr.id === selectedAddress);

  const [currentChallenge, setCurrentChallenge] = useState(null);

  const [currentPlanName, setCurrentPlanName] = useState(plans?.find((item) => item.name === "Pro Edge account"));

  const navigate = useNavigate();

  // Read during render: the parent consumes and clears the restore flags in a
  // mount effect, which would have already run by the time an effect here could
  // look at them.
  const savedCoupon = useRef(readSavedCoupon()).current;

  const [couponData, setCouponData] = useState({});

  // A coupon is priced against one platform and one account size, so changing
  // either has to drop the discount. Watching the props by identity did far more
  // than that: accBalances is rebuilt as a fresh object every time plans or the
  // selected challenge settle, and broker is reassigned to null and back while the
  // page loads (useLocation state is empty on a reload, and the trading-platform
  // effect then re-picks a default). Each of those counted as a change, so an
  // applied coupon was cleared several times over during a normal mount - which is
  // why applying one right after landing back on this page appeared to do nothing.
  // Key off what actually identifies the choice, and ignore the runs where the
  // page has not settled on a platform and size yet.
  const couponResetKey = `${broker || ""}|${accBalances?.id ?? ""}`;
  const settledCouponKey = useRef(null);
  useEffect(() => {
    if (!broker || !accBalances?.id) return;
    if (settledCouponKey.current === null) {
      // First complete key - this is the page arriving, not a change.
      settledCouponKey.current = couponResetKey;
      return;
    }
    if (settledCouponKey.current === couponResetKey) return;
    settledCouponKey.current = couponResetKey;
    setCouponData({});
  }, [couponResetKey, broker, accBalances?.id]);

  const [isRefundPolicy, setIsRefundPolicy] = useState(false);
  const [proEdgeCheckbox, setProEdgeCheckbox] = useState(false);
  const [termsAndConditionCheckBox, settermsAndConditionCheckBox] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const challenge = plans.flatMap((plan) => plan?.challenges.filter((item) => item.id === accBalances?.id));

    setCurrentChallenge(challenge?.[0]);
  }, [accBalances, plans]);

  const [transactionStatus, setTransactionStatus] = useState("success");
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentCode, setCurrentCode] = useState(savedCoupon?.code || "");
  // A coupon that had actually been applied is re-applied once the challenge is
  // known, so the discount comes back from the API rather than from stale storage.
  const couponToReapply = useRef(savedCoupon?.applied ? savedCoupon.code : "");

  const [isSpinner, setIsSpinner] = useState(false);
  const [isSpinner1, setIsSpinner1] = useState(false);
  const [isError, setIsError] = useState(null);
  const handleCoupon = async (e) => {
    setIsSpinner(true);

    // e?.preventDefault();
    const code = currentCode;

    if (!code || code.trim().length === 0) {
      setIsError("Please enter a coupon code");
      setIsSpinner(false);
      return;
    }

    const id = currentChallenge?.id;
    const params = {
      ...(broker === "tradelocker" && { platform: "tradelocker" }),
      ...(addon && { addon: addon }),
      ...(code && { coupon: code }),
    };
    try {
      const res = await applyCoupon(idToken, id, params);
      setCouponData(res);
      setIsSpinner(false);
      console.log("res", res);
    } catch (err) {
      console.log("eeError", err);
      const data = err?.response?.data || {};
      let msg = data?.detail || data?.message || data?.error || data?.non_field_errors?.[0] || (Array.isArray(data) && data[0]) || (typeof data === "string" ? data : null) || "Invalid Coupon Code";

      // Ensure msg is a string for comparison
      if (Array.isArray(msg)) {
        msg = msg[0];
      }

      if (typeof msg === "string") {
        const lowerMsg = msg.toLowerCase().trim();
        if (lowerMsg.includes("not found") || lowerMsg.includes("invalid coupon")) {
          msg = "Coupon code not found";
        }
      }

      const status = err?.response?.status || 400;
      // dispatch(returnErrors(msg, status));
      setIsError(msg);
      setIsSpinner(false);
    }
  };
  useEffect(() => {
    addon && handleCoupon();
  }, [addon, accBalance]);

  // Wait for the platform and account size to settle before re-applying, so the
  // price comes back for the combination the user is actually looking at and the
  // reset above cannot clear it a moment later.
  useEffect(() => {
    if (!couponToReapply.current) return;
    if (!currentChallenge?.id || !broker || !accBalances?.id) return;
    couponToReapply.current = "";
    handleCoupon();
  }, [currentChallenge?.id, broker, accBalances?.id]);

  useEffect(() => {
    // While a restored coupon is still waiting to be re-applied, couponData has not
    // caught up yet - writing now would record it as "not applied" and lose the
    // re-apply on the next return trip.
    if (couponToReapply.current) return;
    try {
      if (!currentCode) {
        localStorage.removeItem(COUPON_STORAGE_KEY);
        return;
      }
      localStorage.setItem(COUPON_STORAGE_KEY, JSON.stringify({ code: currentCode, applied: couponData?.coupon_applied === currentCode }));
    } catch (e) {
      console.error("Error persisting coupon code:", e);
    }
  }, [currentCode, couponData?.coupon_applied]);

  // const handleInputChange = async (e) => {
  //   const newValue = e.target.value;
  //   setCouponCode(newValue);

  //   // e?.preventDefault();
  //   const body = {
  //     coupon_code: couponCode,
  //   };
  //   try {
  //     const res = await applyCoupon(idToken, body);
  //     setCouponData(res);
  //   } catch (err) {}

  //   // Use the debounce function to delay the execution of handleCoupon
  //   debounce(handleCoupon, 1000); // 1000ms (1 second) delay
  // };
  useEffect(() => { }, [paymentMethod]);
  const userdata = useSelector((state) => state.user);
  const [userDetails, setUserDetails] = useState(userdata);
  useEffect(() => {
    setUserDetails(userdata);
  }, [userdata]);
  const [naceId, setNaceId] = useState([]);
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = React.useState(false);

  const handleClose = () => setOpen(false);

  const location = useLocation();
  const currentPath = location.pathname;

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [isPopupClosed, setIsPopupClosed] = useState(false);

  const serviceType = selectedBrand?.brand === "crypto_edge" ? "crypto_edge" : selectedBrand?.brand === "equity_edge" ? "forex" : "forex";
  const [sessionToken, setSessionToken] = useState("");
  const [orderId, setOrderId] = useState("");
  const [marketingEmails, setMarketingEmails] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    unlockAudio();
    handleAPI(e);
  };
  const isEthiopia = () => {
    const vals = [
      selectRapydCountry?.value,
      selectPaymidCountry?.value,
      selectedCountry?.value,
      formData?.country,
      formData?.country_code,
      addressDetails?.country,
      activeAddr?.country
    ];

    return (selectedValue?.id === 23 || selectedValue?.id === 24) && vals.some((v) => v?.toString().toUpperCase() === "ET" || v?.toString().toUpperCase() === "ETHIOPIA");
  };

  useEffect(() => {
    if (isPopupClosed) {
      handleSubmit();
    }
  }, [isPopupClosed === true]);

  useEffect(() => {
    const clearPaymentState = () => {
      setSessionToken("");
      setOrderId("");
      setIsSpinner(false);
      setIsSpinner1(false);
    };

    window.addEventListener("pageshow", clearPaymentState);
    window.addEventListener("pagehide", clearPaymentState);

    return () => {
      window.removeEventListener("pageshow", clearPaymentState);
      window.removeEventListener("pagehide", clearPaymentState);
    };
  }, []);
  const handlePopupClose = () => {
    setShowMessageModal(false); // Hide the popup
    setIsPopupClosed(true); // Mark popup as closed
    handleAPI(); // Call the API after closing the popup
    handleCancel();
  };

  const handleCancel = () => {
    setShowMessageModal(false); // Close the modal
  };

  const handleAPI = async (e) => {
    // if (!selectRapydCountry?.value && paymentMethod.active === "rapyd") {
    //   dispatch(returnErrors("Please select your country", 400));
    //   return;
    // }
    setIsSpinner1(true);

    if (e) {
      e.preventDefault();
    }

    if (publicCheckout && !formData?.country) {
      dispatch(returnErrors("Please add your country", 400));
      setIsSpinner1(false);
      return;
    }

    if (!publicCheckout && !formData?.country_code.trim()) {
      dispatch(returnErrors("Please add your country code", 400));
      setIsSpinner1(false);
      return;
    }

    if (publicCheckout && !addressDetails?.phone) {
      dispatch(returnErrors("Please add your phone number", 400));
      setIsSpinner1(false);
      return;
    }

    if (broker === "" || broker === null) {
      dispatch(returnErrors("Please select a broker/trading platform", 400));
      setIsSpinner1(false);
      return;
    }

    if (publicCheckout && !formData?.email === null) {
      dispatch(returnErrors("Please add your email address", 400));
      setIsSpinner1(false);
      return;
    }

    if (!formData?.first_name?.trim()) {
      dispatch(returnErrors("Please add your first name", 400));
      setIsSpinner1(false);
      return;
    }
    if (!formData?.last_name?.trim()) {
      dispatch(returnErrors("Please add your last name", 400));
      setIsSpinner1(false);
      return;
    }
    if (!formData?.country?.trim()) {
      dispatch(returnErrors("Please select your country", 400));
      setIsSpinner1(false);
      return;
    }
    if (!formData?.contact?.trim()) {
      dispatch(returnErrors("Please add your contact number", 400));
      setIsSpinner1(false);
      return;
    }

    // if (selectedCountry === null) {
    //   dispatch(returnErrors("Please select your country", 400));
    //   setIsSpinner1(false);
    //   return;
    // }
    if (paymentMethod.value === "fibonatix" && selectedCountry === null) {
      dispatch(returnErrors("Please select your country", 400));
      setIsSpinner1(false);
      return;
    }

    if (paymentMethod.value === "paytiko" && selectRapydCountry === null) {
      dispatch(returnErrors("Please select your country", 400));
      setIsSpinner1(false);
      return;
    }

    if (paymentMethod.value?.toLowerCase() === "paymid" && selectPaymidCountry === null) {
      dispatch(returnErrors("Please select your country", 400));
      setIsSpinner1(false);
      return;
    }

    // checking some country don't have any state so add validation to check if state is there or not
    // if (selectedCountry?.states?.length > 0) {
    //   if (selectedState === null) {
    //     dispatch(returnErrors("Please select your state", 400));
    //     setIsSpinner1(false);
    //     return;
    //   }
    // }
    if (selectedCountry?.states?.length > 0) {
      if (paymentMethod.value === "fibonatix" && selectedState === null) {
        dispatch(returnErrors("Please select your state", 400));
        setIsSpinner1(false);
        return;
      }
    }

    if (paymentMethod.value === "fibonatix") {
      if (addressDetails.zipCode === "" || addressDetails.city.trim() === "" || addressDetails.phone === "") {
        dispatch(returnErrors("Please fill all the details", 400));
        setIsSpinner1(false);
        return;
      }
    }

    if (paymentMethod.value === "paytiko") {
      if (!addressDetails.city || addressDetails.city.trim() === "") {
        dispatch(returnErrors("Please enter your City", 400));
        setIsSpinner1(false);
        return;
      }
    }

    if (paymentMethod.value?.toLowerCase() === "paymid") {
      if (!addressDetails.city || addressDetails.city.trim() === "") {
        dispatch(returnErrors("Please enter your City", 400));
        setIsSpinner1(false);
        return;
      }
    }

    if (!publicCheckout && userAddress?.length <= 0) {
      dispatch(returnErrors("Please enter your Invoice Details", 400));
      setIsSpinner1(false);
      return;
    }

    if (!publicCheckout) {
      const response = await updateUserDetailsRequest({ formData, idToken });
      console.log(response, "responseresponse");
      if (response.status > 399) {
        return;
      }
    }

    const basePayload = {
      promo: couponData?.final_price ? currentCode : "",
      marketing_emails: marketingEmails,
      checkout_source: publicCheckout ? "public" : "dashboard",
    };

    const body =
      paymentMethod.value?.toLowerCase() === "paymid"
        ? {
          ...basePayload,
          challenge_id: currentChallenge?.id,
          ...(selectedBrand?.brand === "crypto_edge" ? { addon: addon } : {}),
          payment_method: paymentMethod.active,
          email: formData?.email,
          first_name: formData?.first_name,
          last_name: formData?.last_name,
          broker: broker,
          service_type: serviceType,
          country: activeAddr ? getCountryCode(activeAddr.country) : selectPaymidCountry?.value,
          city: activeAddr ? activeAddr.city : addressDetails?.city,
          phone: activeAddr ? activeAddr.number : addressDetails.phone,
          country_code: formData?.country_code,

          address: activeAddr
            ? {
                country: getCountryCode(activeAddr.country),
                city: activeAddr.city,
                apartment_no: "",
                zip_code: activeAddr.zip_code || "",
                state: activeAddr.state || "",
                street_address: ((activeAddr.apartment_no || activeAddr.house_number || "") + " " + (activeAddr.street_address || "")).trim(),
              }
            : selectPaymidCountry
              ? {
                  country: selectPaymidCountry.value,
                  city: addressDetails?.city,
                  apartment_no: "",
                }
              : {},
        }
        : paymentMethod.value === "paytiko"
          ? {
            ...basePayload,
            challenge_id: currentChallenge?.id,
            ...(selectedBrand?.brand === "crypto_edge" ? { addon: addon } : {}),
            payment_method: paymentMethod.active,
            email: formData?.email,
            first_name: formData?.first_name,
            last_name: formData?.last_name,
            // promo: couponData?.final_price ? currentCode : "",
            broker: broker,
            service_type: serviceType,
            country: activeAddr ? getCountryCode(activeAddr.country) : selectedCountry?.value,
            phone: activeAddr ? activeAddr.number : addressDetails.phone,
            country_code: formData?.country_code,

            address: activeAddr
              ? {
                  country: getCountryCode(activeAddr.country),
                  city: activeAddr.city,
                  apartment_no: "",
                  zip_code: activeAddr.zip_code || "",
                  state: activeAddr.state || "",
                  street_address: ((activeAddr.apartment_no || activeAddr.house_number || "") + " " + (activeAddr.street_address || "")).trim(),
                }
              : selectRapydCountry
                ? { country: selectRapydCountry.value, city: addressDetails?.city }
                : {},
          }
          : publicCheckout === true && paymentMethod.value === "fibonatix"
            ? {
              ...basePayload,
              challenge_id: currentChallenge?.id,
              ...(selectedBrand?.brand === "crypto_edge" ? { addon: addon } : {}),
              payment_method: paymentMethod.active,
              email: formData?.email,
              first_name: formData?.first_name,
              last_name: formData?.last_name,
              // promo: couponData?.final_price ? currentCode : "",
              broker: broker,
              service_type: serviceType,
              country: selectedCountry?.value,
              phone: addressDetails.phone,
              country_code: formData?.country_code,

              address: selectRapydCountry
                ? { country: selectRapydCountry.value }
                : {
                  city: addressDetails?.city,
                  zip_code: addressDetails?.zipCode,
                  country: selectedCountry?.value,
                  state: selectedState?.value || "",
                  phone: addressDetails?.phone,
                },
            }
            : paymentMethod.value === "coinpayments" && publicCheckout
              ? {
                ...basePayload,
                challenge_id: currentChallenge?.id,
                ...(selectedBrand?.brand === "crypto_edge" ? { addon: addon } : {}),
                payment_method: paymentMethod.active,
                crypto: paymentMode.value,
                service_type: serviceType,
                // promo: couponData?.final_price ? currentCode : "",
                email: formData?.email,
                first_name: formData?.first_name,
                last_name: formData?.last_name,
                broker: broker,

                country: selectedCountry?.value,
                phone: addressDetails.phone,
                country_code: formData?.country_code,
              }
              : paymentMethod.value === "coinpayments"
                ? {
                  ...basePayload,
                  challenge_id: currentChallenge?.id,
                  ...(selectedBrand?.brand === "crypto_edge" ? { addon: addon } : {}),
                  payment_method: paymentMethod.active,
                  crypto: paymentMode.value,
                  service_type: serviceType,
                  // promo: couponData?.final_price ? currentCode : "",
                  email: formData?.email,
                  first_name: formData?.first_name,
                  last_name: formData?.last_name,
                  broker: broker,

                  // country: selectedCountry?.value,
                  // phone: addressDetails.phone,
                  // country_code: formData?.country_code,
                }
                : paymentMethod.value === "fibonatix"
                  ? {
                    ...basePayload,
                    challenge_id: currentChallenge?.id,
                    ...(selectedBrand?.brand === "crypto_edge" ? { addon: addon } : {}),
                    payment_method: "fibonatix",
                    service_type: serviceType,
                    // promo: couponData?.final_price ? currentCode : "",
                    email: formData?.email,
                    broker: broker,

                    country: activeAddr ? getCountryCode(activeAddr.country) : selectedCountry?.value,
                    phone: activeAddr ? activeAddr.number : addressDetails.phone,
                    country_code: formData?.country_code,

                    address: activeAddr
                      ? {
                          city: activeAddr.city,
                          zip_code: activeAddr.zip_code || "",
                          country: getCountryCode(activeAddr.country),
                          state: activeAddr.state || "",
                          phone: activeAddr.number,
                          apartment_no: "",
                          street_address: ((activeAddr.apartment_no || activeAddr.house_number || "") + " " + (activeAddr.street_address || "")).trim(),
                        }
                      : {
                          city: addressDetails.city,
                          zip_code: addressDetails.zipCode,
                          country: selectedCountry?.value,
                          state: selectedState?.value || "",
                          phone: addressDetails.phone,
                        },
                  }
                  : paymentMethod.value === "fibonatix" && publicCheckout === true
                    ? {
                      ...basePayload,
                      challenge_id: currentChallenge?.id,
                      ...(selectedBrand?.brand === "crypto_edge" ? { addon: addon } : {}),
                      payment_method: "fibonatix",
                      service_type: serviceType,
                      // promo: couponData?.final_price ? currentCode : "",
                      email: formData?.email,
                      broker: broker,

                      country: selectedCountry?.value,
                      phone: addressDetails.phone,
                      country_code: formData?.country_code,

                      address: {
                        city: addressDetails.city,
                        zip_code: addressDetails.zipCode,
                        country: selectedCountry.value,
                        state: selectedState?.value || "",
                        phone: addressDetails.phone,
                      },
                    }
                    : publicCheckout === true
                      ? {
                        ...basePayload,
                        challenge_id: currentChallenge?.id,
                        ...(selectedBrand?.brand === "crypto_edge" ? { addon: addon } : {}),
                        payment_method: paymentMethod.active,
                        email: formData?.email,
                        service_type: serviceType,
                        first_name: formData?.first_name,
                        last_name: formData?.last_name,
                        // promo: couponData?.final_price ? currentCode : "",
                        broker: broker,

                        country: selectedCountry?.value,
                        phone: addressDetails.phone,
                        country_code: formData?.country_code,
                      }
                      : {
                        ...basePayload,
                        challenge_id: currentChallenge?.id,
                        ...(selectedBrand?.brand === "crypto_edge" ? { addon: addon } : {}),
                        payment_method: paymentMethod.active,
                        service_type: serviceType,
                        // promo: couponData?.final_price ? currentCode : "",
                        // address: selectRapydCountry ? {country: selectRapydCountry.value} : selectedAddress,
                        first_name: formData?.first_name,
                        last_name: formData?.last_name,
                        broker: broker,
                        email: formData?.email,
                        city: paymentMethod.value?.toLowerCase() === "paymid" ? (activeAddr ? activeAddr.city : addressDetails?.city) : undefined,
                        country: paymentMethod.value?.toLowerCase() === "paymid" ? (activeAddr ? getCountryCode(activeAddr.country) : selectPaymidCountry?.value || selectedCountry?.value) : undefined,
                        address:
                          paymentMethod.value?.toLowerCase() === "paymid"
                            ? (activeAddr
                                ? {
                                    country: getCountryCode(activeAddr.country),
                                    city: activeAddr.city,
                                    apartment_no: "",
                                    zip_code: activeAddr.zip_code || "",
                                    state: activeAddr.state || "",
                                    street_address: ((activeAddr.apartment_no || activeAddr.house_number || "") + " " + (activeAddr.street_address || "")).trim(),
                                  }
                                : {
                                    country: selectPaymidCountry?.value || selectedCountry?.value,
                                    city: addressDetails?.city,
                                    apartment_no: "",
                                  })
                            : paymentMethod.value !== "paytiko"
                              ? selectedAddress
                              : (activeAddr
                                  ? {
                                      country: getCountryCode(activeAddr.country),
                                      city: activeAddr.city,
                                      apartment_no: "",
                                      zip_code: activeAddr.zip_code || "",
                                      state: activeAddr.state || "",
                                      street_address: ((activeAddr.apartment_no || activeAddr.house_number || "") + " " + (activeAddr.street_address || "")).trim(),
                                    }
                                  : {
                                      country: selectRapydCountry?.value,
                                      city: addressDetails?.city,
                                    }),
                      };

    try {
      if (!formData.email?.trim() && !idToken) {
        dispatch(returnErrors("Please enter your email", 400));
        setIsSpinner1(false);
        return;
      }
      // if (broker === "mt5") {
      //   if (!isPopupClosed) {
      //     setShowMessageModal(true);
      //     setIsSpinner1(false);

      //     return; // Prevent further execution until the popup is closed
      //   }
      // }

      if (formData?.email && publicCheckout) {
        const res = await initiatePaymentpublic(body, dispatch);

        dispatch(setLastPayment(res));
        localStorage.setItem("lastPayment", JSON.stringify(res));
        setSessionToken(res?.session_token);
        setOrderId(res?.data.id);
        if (res.url) {
          // let payload = {data: res?.auth};
          // // res.status < 399 &&
          // dispatch(setAuthenticationSuccess(payload));
          // dispatch(getUser(res?.auth?.idToken));

          redirectToProvider(res?.url);
          setIsSpinner1(false);
        }
        if (paymentMethod.active === "nace") {
          setNaceId(res?.data);
          // setOpen(true);
          setIsSpinner1(false);
          setVisible(true);
        }
      } else {
        // hitting free account api if price is 0
        setIsSpinner1(true);
        // const response = await handleSave();

        // if (response) {
        if (!publicCheckout && (formData.first_name?.trim() === "" || formData.last_name?.trim() === "" || formData?.email?.trim() === "")) {
          dispatch(returnErrors("Please enter your Invoice details", 400));
          setIsSpinner1(false);
          return;
        }

        if (currentChallenge?.price <= 0) {
          const res = await createFreeAccount(idToken, { challenge_id: currentChallenge?.id }, dispatch);
          dispatch(setLastPayment(res));
          localStorage.setItem("lastPayment", JSON.stringify(res));
          setIsSpinner1(false);
          res.status < 399 && navigate("/");
          return;
        }
        const res = await initiatePayment(idToken, body, dispatch);

        dispatch(setLastPayment(res));
        localStorage.setItem("lastPayment", JSON.stringify(res));
        setSessionToken(res?.session_token);
        setOrderId(res?.data.id);
        if (res.url) {
          redirectToProvider(res.url);
          setIsSpinner1(false);
        }
        if (paymentMethod.active === "nace") {
          // window.location.replace("https://apps.newagecrypto.com/widget/nacepay.js?v4");
          setNaceId(res?.data);
          // setOpen(true);
          setIsSpinner1(false);
          setVisible(true);
        }
      }
    } catch (err) {
      setModalOpen(true);
      setTransactionStatus("error");
      setIsSpinner1(false);
    }
  };

  // let planOptions = plans.map((plan) => ({
  //   label: plan.name,
  //   value: plan.name,
  //   id: plan.id,
  // }));
  // const [selectedValue, setSelectedValue] = useState(planOptions.find((plan) => plan.id === currentChallenge?.id) || planOptions[0]);
  const [selectedValue, setSelectedValue] = useState(selectedValues);

  useEffect(() => {
    setSelectedValue(selectedValues);
  }, [selectedValues]);

  useEffect(() => {
    const conditionMet = true;

    if (conditionMet) {
      const script = document.createElement("script");

      script.src = "https://apps.newagecrypto.com/widget/nacepay.js?v4";

      document.body.appendChild(script);

      // return () => {
      //   document.body.removeChild(script);
      // };
    }
  }, [open]);

  const bellRef = useRef(null);
  const profileRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (bellRef.current && !bellRef.current.contains(event.target) && profileRef.current && !profileRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (couponData?.discount) {
      handleCoupon();
    }
  }, [accBalance]);

  useEffect(() => {
    // Function to check if the payment modal is open
    function checkModal() {
      const paymentModal = document.querySelector(".btnpay");
      if (paymentModal) {
        paymentModal.addEventListener("click", () => {
          setOpen(false);
          navigate("/");
        });
      }
    }

    // Use MtationObserver to watch for changes in the DOM
    const observer = new MutationObserver(checkModal);

    // Start observing changes in the body (or specific parent element where the modal might be added)
    observer.observe(document.body, { childList: true, subtree: true });

    // Clean up function
    return () => {
      observer.disconnect(); // Disconnect the observer when the component unmounts
    };
  }, []); // Empty dependency array ensures the effect runs only once when the component mounts

  // This component doesn't render anything visible
  const handleRemovedCoupon = () => {
    setCouponData({});
    setAddon();
    setCurrentCode("");
  };

  useEffect(() => {
    const clearPaymentState = () => {
      setSessionToken("");
      setOrderId("");
      setIsSpinner(false);
      setIsSpinner1(false);
    };

    window.addEventListener("pageshow", clearPaymentState);
    window.addEventListener("pagehide", clearPaymentState);

    return () => {
      window.removeEventListener("pageshow", clearPaymentState);
      window.removeEventListener("pagehide", clearPaymentState);
    };
  }, []);
  const handleClosePayment = () => {
    setVisible(false);
    setTimeout(() => {
      setOpen(true);
    }, 600);
  };

  console.log("selectedValue", selectedValue);

  // Helper function to get platform display name
  const getPlatformLabel = (brokerValue) => {
    const platformMap = {
      mt5: "MT5",
      matchtrade: "Match-Trader",
      // ce_terminal: "CE Terminal",
      // tradelocker: "TradeLocker",
    };
    return platformMap[brokerValue] || "NA";
  };

  return (
    <>
      {paymentMethod.value?.toLowerCase() === "paytiko" && sessionToken && orderId && (
        <PaytikoCashier
          sessionToken={sessionToken}
          orderId={orderId}
        />
      )}
      <PreSaleModal
        showMessageModal={showMessageModal}
        handleCancel={handleCancel}
        handlePopupClose={handlePopupClose}
      />

      <div
        style={{ display: open ? "block" : "none" }}
        className="nacemodal_container"
        onClick={() => setOpen(false)}
      >
        <div
          className="nacemodal"
          onClick={(e) => e.stopPropagation()}
          ref={profileRef}
        >
          <div
            ref={bellRef}
            nacepay="Paywidget"
            nacepay_id="d46168ab-6e60-45c6-a673-27d23c416068"
            amount={naceId.amount}
            currency="USD"
            ref_id={naceId.id}
            className="nacepaypaybtn"
          ></div>
          <p>Please click on this button to continue</p>
        </div>
      </div>
      <Modal
        title="Payment Confirmation"
        open={visible}
        // onCancel={() => setVisible(false)}
        footer={null} // Removes both default buttons
        className="payment-confirmation-modal"
        style={{ backgroundColor: "#000" }}
      >
        <Text>
          Please ensure you send payment using the correct Coin AND Network specified on the payment page, and that you read and follow the payment instructions in full. Failure to do so may result in
          a permanent loss of your deposit.
        </Text>
        <br />
        <Text className="danger">DO NOT send USDT on the BNB Smart Chain (BSC) Network as this will not be received and cannot be refunded.</Text>
        <Paragraph />

        <div className="custom-footer">
          <Button
            type="default"
            onClick={() => handleClosePayment()}
          >
            I Understand
          </Button>
        </div>
      </Modal>
      {/* </Modal> */}
      {/* <div
            nacepay="Paywidget"
            nacepay_id="d46168ab-6e60-45c6-a673-27d23c416068"
            amount={30.00}
            currency="USD"
            ref_id={"jerejrgyar6"}
            className="nacepaypaybtn"
          ></div> */}

      <div className="summary">
        <div className="summary_wrapper">
          <h1>Order Summary</h1>
          <div className="summary_upper">
            <div className="summary_upper_wrapper">
              <h3>Challenge</h3>
              <p className="summary_upper">
                {selectedValue?.value || "NA"} - {accBalance?.label || "NA"}
              </p>

              <h3>Platform: {getPlatformLabel(broker)}</h3>
              {/* <div>
                <Select
                  value={selectedValue}
                  // options={publicCheckout ? planOptions.filter((plan) => plan.value !== "Free Trial") : planOptions}
                  styles={customStyles}
                  // onChange={(selectedOption) => handlePlanChange(selectedOption)}
                  isDisabled={true}
                />
              </div> */}
              {/* <h3>Challenge Amount</h3>
              <p className="summary_upper_coupon">{accBalance?.label || "NA"}</p> */}
              {/* <div>
                <Select
                  value={accBalance}
                  // options={accBalanceOptions}
                  styles={customStyles}
                  // onChange={(selectedOption) => {
                  //   handleAccBalanceChange(selectedOption);
                  // }}
                  isDisabled={true}
                />
              </div> */}
              <div className="coupon-header">
                <h3>Have a coupon?</h3>
              </div>
              <div className="summary_upper_coupon discountCodeInputs">
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    className={isError ? "error-border" : ""}
                    onSubmit={handleCoupon}
                    type="text"
                    value={currentCode}
                    placeholder="ENTER COUPON CODE"
                    onChange={async (e) => {
                      setIsError(null);
                      setCurrentCode(e.target.value.toUpperCase());
                    }}
                    disabled={couponData?.coupon_applied === currentCode}
                    style={{ paddingRight: couponData?.coupon_applied === currentCode ? "40px" : "20px" }}
                  />
                  {couponData?.coupon_applied === currentCode && (
                    <div
                      className="remove_coupon_icon"
                      onClick={() => handleRemovedCoupon()}
                    >
                      <Cross />
                    </div>
                  )}
                </div>

                <button
                  style={{
                    background: couponData?.coupon_applied === currentCode ? "#333" : "",
                    color: couponData?.coupon_applied === currentCode ? "#a3a3a3" : "",
                    maxWidth: "130px",
                  }}
                  onClick={handleCoupon}
                  disabled={isSpinner || couponData?.coupon_applied === currentCode}
                  className="applyButton"
                >
                  {isSpinner ? <Spinner /> : "Apply"}
                </button>
              </div>
              {isError && (
                <p
                  className="error"
                  style={{
                    color: "#fd2d2d",
                    fontSize: "12px",
                  }}
                >
                  {isError}
                </p>
              )}
              {couponData?.coupon_applied === currentCode && !isError && (
                <p
                  style={{
                    color: "#36d66b",
                    fontSize: "12px",
                  }}
                >
                  Coupon applied! {couponData?.discount !== undefined ? `(${couponData.discount_percent}% discount)` : ""}
                </p>
              )}
            </div>
          </div>
          <div className="summary_lower">
            <div className="summary_lower_wrapper">
              <div className="summary_lower_top">
                <div className="summary_lower_top_wrapper">
                  {/* <div>
                    <p className="title">Challenge Name</p>
                    <h5 className="value">{currentChallenge?.name}</h5>
                  </div> */}
                  {/* <div>
                    <p>Transaction ID:</p>
                  </div> */}
                  {couponData?.coupon_applied && (
                    <div className="coupon_discount_row">
                      <p className="title">Coupon Discount</p>
                      <h5 className="value">
                        ${(couponData?.actual_price - couponData?.final_price).toFixed(2)}
                        {/* ({couponData?.discount || 0}% discount) */}
                      </h5>
                    </div>
                  )}
                  <div>
                    <p className="title">Subtotal</p>
                    <h5 className="value">
                      {broker === "tradelocker"
                        ? `$${Number(currentChallenge?.tradelocker_price ? currentChallenge?.tradelocker_price : "0").toFixed(2)}`
                        : `$${Number(currentChallenge?.price ? currentChallenge?.price : "0").toFixed(2)}`}
                    </h5>
                  </div>
                  {couponData.addon_amount && (
                    <div>
                      <p className="title">Add-Ons</p>
                      <h5 className="value addon">+${couponData?.addon_amount?.toFixed(2)}</h5>
                    </div>
                  )}
                </div>
              </div>
              <div className="summary_lower_middle">
                <div className="summary_lower_middle_wrapper">
                  <div>
                    <h5 className="title">Total</h5>
                    <h4 className="value">
                      $
                      {(Number(couponData?.final_price) ? Number(couponData?.final_price) : Number(broker === "tradelocker" ? currentChallenge?.tradelocker_price : currentChallenge?.price)) ===
                        undefined
                        ? "0.00"
                        : (Number(couponData?.final_price)
                          ? Number(couponData?.final_price)
                          : Number(broker === "tradelocker" ? currentChallenge?.tradelocker_price : currentChallenge?.price)
                        ).toFixed(2)}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="summary_lower_bottom">
                <div className="summary_lower_bottom_top">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isRefundPolicy}
                        onChange={() => setIsRefundPolicy((prev) => !prev)}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            color: isRefundPolicy ? (selectedBrand?.brand === "equity_edge" ? "#36D66B" : selectedBrand?.brand === "crypto_edge" ? "#FCD535" : "#36D66B") : "#A3A3A3",

                            borderRadius: "11px",
                          },
                          "&.Mui-checked": {
                            // backgroundColor: "#158F91", // Background color when checked
                          },
                        }}
                      />
                    }
                  />
                  <p>
                    I declare that I have read and agree with the
                    <Link
                      target="_blank"
                      to="https://equityedge.io/refunds/"
                    >
                      <span> Refund Policy</span>
                    </Link>
                  </p>
                </div>

                <div className="summary_lower_bottom_top">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={termsAndConditionCheckBox}
                        onChange={() => settermsAndConditionCheckBox((prev) => !prev)}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            color: termsAndConditionCheckBox ? (selectedBrand?.brand === "equity_edge" ? "#36D66B" : selectedBrand?.brand === "crypto_edge" ? "#FCD535" : "#36D66B") : "#A3A3A3",
                            borderRadius: "11px",
                          },
                          "&.Mui-checked": {
                            // backgroundColor: "#158F91", // Background color when checked
                          },
                        }}
                      />
                    }
                  />
                  <p>
                    I declare that I have read and agree with the
                    <Link
                      target="_blank"
                      to="https://equityedge.io/terms-and-conditions/"
                    >
                      <span> Terms & Conditions</span>
                    </Link>
                  </p>
                </div>
                {selectedValues?.id === 13 && (
                  <div className="summary_lower_bottom_top">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={proEdgeCheckbox}
                          onChange={() => setProEdgeCheckbox((prev) => !prev)}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              color: proEdgeCheckbox ? (selectedBrand?.brand === "equity_edge" ? "#36D66B" : selectedBrand?.brand === "crypto_edge" ? "#FCD535" : "#36D66B") : "#A3A3A3",
                              borderRadius: "11px",
                            },
                            "&.Mui-checked": {
                              // backgroundColor: "#158F91", // Background color when checked
                            },
                          }}
                        />
                      }
                    />
                    <p>
                      I have read, understood, and agree to the{" "}
                      <Link
                        target="_blank"
                        to="https://equityedge.io/instant-account-contract"
                      >
                        <span> Instant Account Contract.</span>
                      </Link>{" "}
                      By checking this box, I accept and electronically sign the contract, confirming my agreement to its terms and conditions for the instant issuance of my Instant Account.
                    </p>
                  </div>
                )}
                <div className="summary_lower_bottom_top">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={marketingEmails}
                        onChange={() => setMarketingEmails((prev) => !prev)}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            color: marketingEmails ? (selectedBrand?.brand === "equity_edge" ? "#36D66B" : selectedBrand?.brand === "crypto_edge" ? "#FCD535" : "#36D66B") : "#A3A3A3",
                            borderRadius: "11px",
                          },
                        }}
                      />
                    }
                  />
                  <p>I agree to receive marketing emails, updates, and offers from Equity Edge Ltd.</p>
                </div>

                {!isRefundPolicy && (
                  <div className="red_text">
                    {
                      <p
                        style={{
                          visibility: !isRefundPolicy ? "visible" : "hidden",
                        }}
                      >
                        Please accept the Refund Policy
                      </p>
                    }
                  </div>
                )}
                {!termsAndConditionCheckBox && (
                  <div className="red_text">
                    {
                      <p
                        style={{
                          visibility: !termsAndConditionCheckBox ? "visible" : "hidden",
                        }}
                      >
                        Please accept the Terms & Conditions
                      </p>
                    }
                  </div>
                )}
                {selectedValues?.id === 13 && !proEdgeCheckbox && (
                  <div className="red_text">
                    {
                      <p
                        style={{
                          visibility: !proEdgeCheckbox ? "visible" : "hidden",
                        }}
                      >
                        Please accept and electronically sign the Instant Account Contract.
                      </p>
                    }
                  </div>
                )}
                <button
                  className={`buy_now ${isEthiopia() ? "not-allowed-cursor" : ""}`}
                  onClick={(e) => (isEthiopia() ? null : handleSubmit(e))}
                  disabled={
                    selectedValues?.id === 13
                      ? !isRefundPolicy || !termsAndConditionCheckBox || !proEdgeCheckbox || paymentMethod.value === null
                      : !isRefundPolicy || !termsAndConditionCheckBox || paymentMethod.value === null
                  }
                >
                  {isSpinner1 ? (
                    <div
                      style={{
                        margin: "0 auto",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Spinner />
                    </div>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        justifyContent: "center",
                        color: "#000",
                      }}
                    >
                      <span style={{ color: "#000" }}>Pay Now:</span>$
                      {(Number(couponData?.final_price) ? Number(couponData?.final_price) : Number(broker === "tradelocker" ? currentChallenge?.tradelocker_price : currentChallenge?.price)) ===
                        undefined
                        ? "0.00"
                        : (Number(couponData?.final_price)
                          ? Number(couponData?.final_price)
                          : Number(broker === "tradelocker" ? currentChallenge?.tradelocker_price : currentChallenge?.price)
                        ).toFixed(2)}
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {transactionStatus === "success" && isModalOpen ? (
        <SuccessModal
          setModalOpen={setModalOpen}
          title="Successful!!"
          desc="Congratulation
        transaction was successful"
          btnText="Close"
        />
      ) : transactionStatus === "error" && isModalOpen ? (
        <></>
      ) : null}
    </>
  );
}

export default Summary;

export const unlockAudio = () => {
  const audio = new Audio();
  audio.play().catch(() => { });
};
